/**
 * Maps currency codes to their symbols
 */
export function getCurrencySymbol(currencyCode: string): string {
  const currencySymbols: Record<string, string> = {
    USD: "$",
    EUR: "€",
    GBP: "£",
    JPY: "¥",
    CNY: "¥",
    AUD: "A$",
    CAD: "C$",
    CHF: "CHF",
    INR: "₹",
    RUB: "₽",
    BRL: "R$",
    KRW: "₩",
    MXN: "MX$",
    NZD: "NZ$",
    SEK: "kr",
    NOK: "kr",
    DKK: "kr",
    SGD: "S$",
    HKD: "HK$",
    ZAR: "R",
    TRY: "₺",
    PLN: "zł",
    THB: "฿",
    IDR: "Rp",
    MYR: "RM",
    PHP: "₱",
    CZK: "Kč",
    ILS: "₪",
    CLP: "CLP$",
    AED: "AED",
    SAR: "SAR",
    ARS: "ARS$",
    COP: "COL$",
    EGP: "E£",
    HUF: "Ft",
    PKR: "₨",
    RON: "lei",
    VND: "₫",
    BDT: "৳",
    NGN: "₦",
    UAH: "₴",
    BTC: "₿",
    ETH: "Ξ",
  }

  return currencySymbols[currencyCode] || currencyCode
}
